import { DialerPhoneNumberOption } from '../../../shared/components/dialer/types';

export interface CallLog {
  id: number;
  callId: string;
  prospectName: string;
  prospectPhone: DialerPhoneNumberOption;
  callDirection: CallDirection;
  recordingDuration: number;
  callDuration: number; // in seconds
  ringDuration: number; // in seconds
  callOutcome: CallOutcomes;
  dateTime: string; // ISO8601 timestamp
  callerHost: string; // User name who made/received the call
  source: CallSource;
  callSource?: DialerCallSourceEnum;
  recordingUrl?: string | null;
  fromNumber?: string;
  // Optional fields used in specific tabs/columns
  forwardedNumber?: DialerPhoneNumberOption;
  attendantUser?: Prospect;
  recipientUser?: Prospect;
  sequenceTitle?: string;
  hasVoicemail?: boolean;
  transcription?: string | null;
  isDirectCall?: boolean;
  isForwarded?: boolean;
  isRecordingPresent?: boolean;
  isSeen?: boolean;
  isTranscriptionInProgress?: boolean;
  /** AI-generated call summary when provided by the API */
  aiSummary?: string | null;
  /** True while an AI summary is being generated */
  isAiSummaryInProgress?: boolean;
  taskId?: number;
  toNumber?: string;
  showBanner?: boolean;
  Banner?: React.ReactNode;
  /** Contact id for opening prospect details (from API `prospect` on detailed logs) */
  prospect?: Prospect;
  /** Whether the current user has access to view this prospect's full details */
  isProspectAccessible?: boolean;
  /** not coming from backedn added for task modal & CRM call initiation  */
  prospectPhoneNumberList?: DialerPhoneNumberOption[] | null;
}

export enum CallDirection {
  Outgoing = 'outgoing',
  Incoming = 'incoming',
  Missed = 'missed',
  MissedWithVoicemail = 'missed-with-voicemail',
}

export enum CallSource {
  Sequence = 'Sequence',
  ManualCall = 'Manual Call',
  Task = 'Task',
  Extension = 'Extension',
}

export interface CallLogsListResponse {
  callLogs: CallLog[];
  total: number;
}

export interface GetCallLogsListPayload {
  pageNum: number;
  pageSize: number;
  search?: string;
  type?: 'all' | 'missed' | 'voicemails';
}
export interface Sequences {
  id: number;
  title: string;
}
export interface Prospect {
  id: number;
  firstName: string;
  lastName: string;
}

export interface CallOutcomes {
  id: number;
  name: string;
  bgColor: string;
  textColor: string;
  sentiment: string;
  isDefault: boolean;
}

export interface DetailedCallLog {
  id?: number;
  phoneNumber?: DialerPhoneNumberOption;
  callType?: 'incoming' | 'outgoing' | 'missed' | string;
  isRecordingPresent?: boolean;
  isSeen?: boolean;
  isForwarded?: boolean;
  isDirectCall?: boolean;
  callDuration?: number;
  ringTime?: number;
  transcription?: string | null;
  recordingDuration?: number;
  callDateTime?: string;
  isTranscriptionInProgress?: boolean;
  aiSummary?: string | null;
  isAiSummaryInProgress?: boolean;

  attendantUser?: Prospect;
  forwardedNumber?: DialerPhoneNumberOption;
  recipientUser?: Prospect;
  user?: Prospect;
  prospect?: Prospect;

  callOutcome?: CallOutcomes;

  source?: CallSource;
  taskId?: number;
  sequence?: Sequences;
  /** Whether the current user has access to view this prospect's full details */
  isProspectAccessible?: boolean;
}

export interface CallLogsResponse {
  allCalls: DetailedCallLog[];
  incomingVoicemails?: DetailedCallLog[];
  missedCalls?: DetailedCallLog[];
  total: number;
}

export interface GetSignedUrlForCallRecordingResponse {
  signedUrl: string;
}

export enum CallSourceActionType {
  MANUAL_TASK = 'Manual Task',
  MANUAL_CALL = 'Manual Call',
  EXTENSION = 'Extension',
}
export enum DialerCallSourceEnum {
  Manual = 'manual',
  CRM = 'crm',
  Task = 'task',
  Extension = 'extension',
}
